import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Field, Form } from 'react-final-form';
import { Button, InputText, InputSelectNative, H2, FieldTermsAgreements, Spinner, DOCTOR_SPECIALTIES, useQuery, validateRequiredField, composeValidators, validateEmail, } from 'shared';
import { WizardDescription } from 'components';
function IntroFormEDS({ submitCallback, locationData, isFetchingLocation, }) {
    const { queryObject: query } = useQuery();
    const hasLocId = query.get('locationId');
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.firstName) {
                errors.firstName = 'First Name Required';
            }
            if (!values.lastName) {
                errors.lastName = 'Last Name Required';
            }
            if (!values.email) {
                errors.email = 'Email Required';
            }
            if (!hasLocId && !values.specialty) {
                errors.specialty = 'Specialty Required';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    const formSubmit = async (values) => {
        // Submitted Values
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                // Form is valid
                if (submitCallback) {
                    await submitCallback(values);
                }
                return undefined;
            }
            else {
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    return (_jsxs("div", { className: "forms-container", children: [_jsx("div", { className: "application-instructions mar-b-32", children: !isFetchingLocation ? (_jsx(WizardDescription, { locationName: locationData?.name, showPracticeInfo: !!(locationData &&
                        locationData.name &&
                        locationData.locationId &&
                        !window.location.host.includes('iframe')), allowChangePractice: false, showFindApplication: false })) : (_jsx(Spinner, {})) }), _jsx(Form, { initialValues: {
                    ...(hasLocId ? { locationId: hasLocId } : {}),
                }, onSubmit: formSubmit, render: ({ handleSubmit, values, submitting, hasValidationErrors }) => {
                    return (_jsxs("form", { onSubmit: handleSubmit, noValidate: true, children: [_jsxs("div", { className: "card border-rad-10 border-width-1", children: [_jsx("div", { className: "card-title text-center pad-b-30 border-b-1 mar-b-20", children: _jsx(H2, { variant: "headline-small", children: "Get Started" }) }), _jsxs("div", { className: "flex-wrap-sm col-gap-20  space-between", children: [_jsx(Field, { name: "firstName", component: InputText, placeholder: "First Name", label: "First Name", required: true, validate: validateRequiredField }), _jsx(Field, { name: "lastName", component: InputText, label: "Last Name", placeholder: "Last Name", required: true, validate: validateRequiredField })] }), _jsxs("div", { className: "flex-wrap-sm col-gap-20 space-between", children: [_jsx(Field, { name: "email", component: InputText, label: "Email Address", placeholder: "Email Address", type: "email", required: true, validate: composeValidators(validateRequiredField, validateEmail) }), !hasLocId ? (_jsx(InputSelectNative, { name: "specialty", label: 'Specialty', options: DOCTOR_SPECIALTIES, placeholder: "Select Your Doctor's Specialty", required: true })) : (_jsx(Field, { name: "locationId", component: 'input', type: "hidden" }))] }), _jsx(FieldTermsAgreements, {})] }), _jsx("br", {}), _jsx(Button, { type: "submit", disabled: !values.agreed || submitting || hasValidationErrors, submitting: submitting, className: `w100 button-warn ${!values.agreed ? `warn-disabled` : ``}`, children: "AGREE AND GET STARTED" }), _jsx("br", {}), _jsx("br", {}), _jsx("br", {}), _jsx("br", {})] }));
                } })] }));
}
export default IntroFormEDS;
